import {
  FileMultipleStroke,
  FloppyDisk1Stroke,
  Pencil1Stroke,
  PlusStroke,
  RefreshCircle1ClockwiseStroke,
  SignPostLeftStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import { ActionButtonV2, getDocumentFormActionButtonsV2 } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

/**
 * Get the title for the form dialog based on form mode and active tab
 */
export const getFormTitle = (formMode: FormMode, activeTab: string) => {
  if (formMode !== 'view') {
    return formMode === 'add' ? 'Mới' : 'Sửa';
  }

  switch (activeTab) {
    case 'info':
      return 'Phiếu nhập kho';
    case 'history':
      return 'Lịch sử';
    default:
      return 'Phiếu nhập kho';
  }
};

/**
 * Get the action buttons for the form dialog based on form mode and active tab
 */
export const getFormActionButtons = (
  formMode: FormMode,
  activeTab: string,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    onClose: () => void;
  }
) => {
  return getDocumentFormActionButtonsV2(formMode, activeTab, handlers);
};

/**
 * Get custom action buttons when hasInvoiceParams is true - hides "Đóng" button
 */
export const getFormActionButtonsWithInvoiceParams = (
  hasInvoiceParams: boolean,
  formMode: FormMode,
  activeTab: string,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    onClose: () => void;
  }
) => {
  const { onAdd, onEdit, onDelete, onCopy } = handlers;
  const defaultActionButtons = getFormActionButtons(formMode, activeTab, handlers);

  // When hasInvoiceParams is true, hide "Đóng" button
  if (hasInvoiceParams) {
    if (formMode !== 'view') {
      // For add/edit mode, only show "Lưu" button
      return (
        <>
          <ActionButtonV2 icon={FloppyDisk1Stroke} title='Lưu' variant='secondary' type='submit' />
        </>
      );
    } else {
      // For view mode, show all buttons except "Đóng"
      switch (activeTab) {
        case 'info':
          return (
            <>
              <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAdd} />
              <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEdit} />
              <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDelete} />
              <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopy} />
            </>
          );
        case 'history':
          return (
            <>
              <ActionButtonV2
                icon={RefreshCircle1ClockwiseStroke}
                title='Refresh'
                variant='secondary'
                onClick={() => console.log('refresh')}
              />
              <ActionButtonV2
                icon={SignPostLeftStroke}
                title='Cố định cột'
                variant='secondary'
                onClick={() => console.log('pin')}
              />
            </>
          );
        default:
          return (
            <>
              <ActionButtonV2 icon={FloppyDisk1Stroke} title='Lưu' type='submit' />
            </>
          );
      }
    }
  }
  return defaultActionButtons;
};
